var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceiveOrderDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15381_107002)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 32,
    height: 32,
    rx: 2,
    fill: "#B5B5B5",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0025 32.6893C31.947 32.6893 31.8916 32.6802 31.8404 32.6576L22.5613 28.655C22.3992 28.5871 22.2969 28.4196 22.2969 28.234C22.2969 28.0483 22.4035 27.8853 22.5613 27.8129L31.8404 23.8103C31.9428 23.765 32.0579 23.765 32.1602 23.8103L41.4394 27.8129C41.6014 27.8808 41.7038 28.0483 41.7038 28.234C41.7038 28.4196 41.5972 28.5826 41.4394 28.655L32.1602 32.6576C32.1091 32.6802 32.0536 32.6893 31.9982 32.6893H32.0025ZM23.8534 28.234L32.0025 31.7475L40.1516 28.234L32.0025 24.7204L23.8534 28.234Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9248 36.5242C28.7628 36.5242 28.5965 36.4925 28.4387 36.4246L20.8055 33.1329C20.4345 32.9744 20.1616 32.6484 20.0508 32.2409C19.9399 31.8334 20.0124 31.4033 20.2512 31.0591L22.3791 27.9667C22.4942 27.7991 22.7032 27.7357 22.8823 27.8127L32.1614 31.8153C32.2851 31.8696 32.3746 31.9783 32.4088 32.1096C32.4429 32.2454 32.4215 32.3903 32.3448 32.499L29.961 35.9582C29.7137 36.3204 29.3214 36.5196 28.9205 36.5196L28.9248 36.5242ZM21.1296 32.2907L28.7628 35.5824C28.9461 35.6639 29.1593 35.596 29.2787 35.4284L31.3384 32.4356L22.8737 28.7817L20.942 31.5889C20.861 31.7066 20.8354 31.8515 20.8738 31.9873C20.9122 32.1232 21.0017 32.2364 21.1296 32.2907Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7258 28.6818C22.5936 28.6818 22.4656 28.6184 22.3846 28.5007L20.4273 25.7025C20.1416 25.2905 20.0478 24.7743 20.18 24.2808C20.3122 23.7873 20.6405 23.3934 21.0883 23.2032L28.2225 20.1243C28.8749 19.8436 29.6254 20.0655 30.0476 20.6676L32.3503 23.9593C32.4271 24.0725 32.4527 24.2174 32.4186 24.3533C32.3844 24.4891 32.2906 24.5978 32.167 24.6521L22.8878 28.6547C22.8366 28.6773 22.7812 28.6863 22.7258 28.6863V28.6818ZM28.8024 20.9031C28.7129 20.9031 28.6276 20.9212 28.5423 20.9574L21.4081 24.0363C21.2077 24.1223 21.0584 24.2989 21.003 24.5208C20.9433 24.7427 20.9859 24.9736 21.1139 25.1592L22.875 27.6767L31.3397 24.0227L29.3653 21.1974C29.2331 21.0072 29.0242 20.8986 28.8067 20.8986L28.8024 20.9031Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2857 28.6824C41.2303 28.6824 41.1791 28.6734 41.1237 28.6507L31.8445 24.6482C31.7209 24.5939 31.6313 24.4852 31.593 24.3494C31.5588 24.2135 31.5844 24.0686 31.6612 23.9554L33.9639 20.6637C34.3861 20.0615 35.1366 19.8397 35.789 20.1204L42.9275 23.1993C43.3753 23.394 43.7036 23.7834 43.8358 24.2769C43.968 24.7704 43.8742 25.2866 43.5885 25.6986L41.6312 28.4968C41.5501 28.6145 41.4222 28.6779 41.29 28.6779L41.2857 28.6824ZM32.6761 24.0279L41.1408 27.6818L42.9019 25.1644C43.0299 24.9787 43.0725 24.7478 43.0128 24.5259C42.9531 24.3041 42.8081 24.1275 42.6077 24.0415L35.4735 20.9626C35.1835 20.8358 34.8466 20.9354 34.6547 21.2071L32.6804 24.0324L32.6761 24.0279Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.084 36.5243C34.6831 36.5243 34.2908 36.3251 34.0435 35.9629L31.6597 32.5037C31.583 32.3905 31.5574 32.2456 31.5958 32.1143C31.6299 31.9785 31.7237 31.8698 31.8431 31.82L41.1222 27.8174C41.3056 27.7405 41.5103 27.7993 41.6254 27.9714L43.7533 31.0638C43.9879 31.408 44.0604 31.8381 43.9538 32.2456C43.8429 32.6531 43.57 32.9791 43.199 33.1376L35.5658 36.4293C35.4081 36.4972 35.2417 36.5289 35.0797 36.5289L35.084 36.5243ZM32.6704 32.4358L34.73 35.4286C34.8494 35.6007 35.0626 35.6641 35.246 35.5826L42.8791 32.2909C43.0028 32.2365 43.0966 32.1279 43.135 31.9875C43.1734 31.8472 43.1478 31.7023 43.0668 31.5891L41.135 28.7818L32.6704 32.4358Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0028 44C31.5082 44 31.0135 43.9004 30.5402 43.6967L23.5083 40.663C22.7706 40.3461 22.293 39.5945 22.293 38.7478V33.4684C22.293 33.2194 22.4849 33.0156 22.7194 33.0156C22.9539 33.0156 23.1458 33.2194 23.1458 33.4684V38.7478C23.1458 39.2232 23.4145 39.6443 23.8281 39.8254L30.86 42.859C31.5934 43.176 32.4037 43.176 33.1414 42.859L40.169 39.8254C40.5826 39.6443 40.8513 39.2232 40.8513 38.7478V33.4684C40.8513 33.2194 41.0432 33.0156 41.2777 33.0156C41.5122 33.0156 41.7041 33.2194 41.7041 33.4684V38.7478C41.7041 39.5945 41.2265 40.3461 40.4888 40.663L33.457 43.6967C32.9836 43.9004 32.489 44 31.9943 44H32.0028Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0046 44C31.77 44 31.5781 43.7963 31.5781 43.5472V24.2272C31.5781 23.9782 31.77 23.7744 32.0046 23.7744C32.2391 23.7744 32.431 23.9782 32.431 24.2272V43.5472C32.431 43.7963 32.2391 44 32.0046 44Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.598 39.1101C24.5425 39.1101 24.4914 39.101 24.4359 39.0784L24.0905 38.929C23.873 38.8339 23.7664 38.5713 23.856 38.3404C23.9455 38.1095 24.1929 37.9963 24.4103 38.0913L24.7557 38.2408C24.9732 38.3358 25.0798 38.5985 24.9903 38.8294C24.9221 39.006 24.7643 39.1101 24.5937 39.1101H24.598Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0075 39.7215C25.952 39.7215 25.9009 39.7125 25.8454 39.6898L25.4147 39.5042C25.1973 39.4091 25.0906 39.1465 25.1802 38.9156C25.2697 38.6846 25.5171 38.5715 25.7346 38.6665L26.1653 38.8522C26.3827 38.9473 26.4893 39.2099 26.3998 39.4408C26.3316 39.6174 26.1738 39.7215 26.0032 39.7215H26.0075Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15381_107002",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15381_107002"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15381_107002",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveOrderDisable);
export default __webpack_public_path__ + "static/media/ReceiveOrderDisable.0ce36fe5953c2fc9af07694cd729a5bc.svg";
export { ForwardRef as ReactComponent };